import { AfterViewInit, Component, ElementRef, HostBinding, OnDestroy, ViewChild } from '@angular/core';

@Component({
  selector: 'app-split-container',
  templateUrl: './split-container.component.html',
  styleUrls: ['./split-container.component.scss'],
})
export class SplitContainerComponent implements AfterViewInit, OnDestroy {
  private readonly infoResizerObserver: ResizeObserver;
  private readonly formResizerObserver: ResizeObserver;

  @HostBinding('style.--scroll-gradient-info-top-visibility') gradientInfoTopVisibility = 'hidden';
  @HostBinding('style.--scroll-gradient-info-bottom-visibility') gradientInfoBottomVisibility = 'hidden';
  @HostBinding('style.--scroll-gradient-form-top-visibility') gradientFormTopVisibility = 'hidden';
  @HostBinding('style.--scroll-gradient-form-bottom-visibility') gradientFormBottomVisibility = 'hidden';

  @ViewChild('leftDiv', { static: true }) leftDiv!: ElementRef<HTMLDivElement>;
  @ViewChild('rightDiv', { static: true }) rightDiv!: ElementRef<HTMLDivElement>;

  constructor() {
    this.infoResizerObserver = new ResizeObserver(() => this.handleScrollLeft());
    this.formResizerObserver = new ResizeObserver(() => this.handleScrollRight());
  }

  ngAfterViewInit() {
    const pseudoElementsHeight = 160;
    const leftEl = this.leftDiv.nativeElement;
    const rightEl = this.rightDiv.nativeElement;
    const hasScrollLeft = leftEl.scrollHeight - pseudoElementsHeight > leftEl.clientHeight;
    const hasScrollRight = rightEl.scrollHeight - pseudoElementsHeight > rightEl.clientHeight;

    if (hasScrollLeft) {
      requestAnimationFrame(() => {
        this.gradientInfoBottomVisibility = 'visible';
      });
    }

    if (hasScrollRight) {
      requestAnimationFrame(() => {
        this.gradientFormBottomVisibility = 'visible';
      });
    }

    this.infoResizerObserver.observe(leftEl);
    this.formResizerObserver.observe(rightEl);
  }

  ngOnDestroy() {
    this.infoResizerObserver.disconnect();
    this.formResizerObserver.disconnect();
  }

  handleScrollLeft() {
    const leftEl = this.leftDiv.nativeElement;

    this.gradientInfoTopVisibility = leftEl.scrollTop > 0 ? 'visible' : 'hidden';
    this.gradientInfoBottomVisibility = leftEl.scrollTop >= leftEl.scrollHeight - leftEl.clientHeight - 5 ? 'hidden' : 'visible';
  }

  handleScrollRight() {
    const rightEl = this.rightDiv.nativeElement;

    this.gradientFormTopVisibility = rightEl.scrollTop > 0 ? 'visible' : 'hidden';
    this.gradientFormBottomVisibility = rightEl.scrollTop >= rightEl.scrollHeight - rightEl.clientHeight - 5 ? 'hidden' : 'visible';
  }
}
